export default "__VITE_ASSET__6eb3bc56__"